import React, { useState } from "react";
import { Box, Button, Grid, List, ListItem, ListItemText } from "@mui/material";
import Moment from "moment";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ListItemIcon from "@mui/material/ListItemIcon";
import IvrStateData from "../../../json/IVRState.json";
import useScrollToTop from "../../../components/CustomHooks/useScrollToTop";

function Confirm({ prevStep, goToStep, handleConfirm, values }) {
  useScrollToTop();

  const {
    tripid,
    permitNbr,
    vtrnbr,
    projectCode,
    portcd,
    etaTripEnd,
    mnkfshOvrflg,
    catchList,
  } = values;
  const newCatch = catchList.map(function ({ id, kept }) {
    return { ivr_species: id, kept, uom: "LB" };
  });
  // TODO: validate this date object assignment
  const displayDate = Moment(etaTripEnd, "YYYY-MM-DD LT").format(
    "DD-MMM-YY LT"
  );
  const [isDisabled, setIsDisabled] = useState(false);

  const _next = (event) => {
    event.preventDefault();
    const dateEnd = Moment(etaTripEnd, "YYYY-MM-DD LT").format("YYMMDDHHmm");
    const statePort = IvrStateData.find(
      (state) => state.STATEPC === portcd.state
    );

    const close_trip_hail = {
      statecd: statePort.STATECD,
      vtrnbr: vtrnbr,
      rsa_project_code: projectCode,
      offloading_port: portcd.id,
      est_trip_end_date: dateEnd,
      mnkfsh_ovrgflg: mnkfshOvrflg,
      catch: newCatch,
    };
    setIsDisabled(true);
    handleConfirm(close_trip_hail);
  };

  const _cancel = (event) => {
    event.preventDefault();
    if (isDisabled) {
      setIsDisabled(false);
    }
    prevStep();
  };

  const handleClick = (step) => {
    goToStep(step);
  };

  return (
    <>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md={5}>
          <List>
            <ListItem style={{ paddingLeft: "7px" }} divider>
              <ListItemText primary={`Vessel Permit: ${permitNbr}`} />
            </ListItem>
            <ListItem style={{ paddingLeft: "7px" }} divider>
              <ListItemText primary={`Trip Id: ${tripid}`} />
            </ListItem>
            <ListItem
              button
              onClick={() => handleClick(1)}
              style={{ paddingLeft: "7px" }}
              divider
            >
              <ListItemText primary={`VTR Number: ${vtrnbr}`} />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
            <ListItem
              button
              onClick={() => handleClick(2)}
              style={{ paddingLeft: "7px" }}
              divider
            >
              <ListItemText primary={`Arrival Port: ${portcd.name}`} />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
            <ListItem
              button
              onClick={() => handleClick(2)}
              style={{ paddingLeft: "7px" }}
              divider
            >
              <ListItemText
                primary={`Monkfish trip limit overage: ${
                  mnkfshOvrflg === "true" ? "Yes" : "No"
                }`}
              />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
            <ListItem
              button
              onClick={() => handleClick(3)}
              style={{ paddingLeft: "7px" }}
              divider
            >
              <ListItemText primary={`Estimated Trip End: ${displayDate}`} />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
            <List>
              <Grid container>
                <Grid item xs={12}>
                  <h3
                    style={{
                      borderBottom: "solid 1px #3f51b5",
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    Catch List
                  </h3>
                </Grid>
              </Grid>
              {catchList.map((item) => {
                return (
                  <ListItem
                    button
                    key={item.id}
                    onClick={() => handleClick(4)}
                    style={{ paddingLeft: "7px" }}
                    divider
                  >
                    <ListItemText>
                      {`Species: ${item.name}`}
                      <br />
                      {`Kept: ${item.kept}`}
                      <br />
                      UOM: LB
                    </ListItemText>
                    <ListItemIcon style={{ minWidth: "0px" }}>
                      <NavigateNextIcon />
                    </ListItemIcon>
                  </ListItem>
                );
              })}
            </List>
          </List>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button
            variant="contained"
            className={isDisabled ? "disabledBtn" : "successBtn"}
            disabled={isDisabled}
            onClick={_next}
          >
            Confirm and Submit
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default Confirm;
